module.exports = __webpack_public_path__ + "media/images/athletes/1763-56140751ce5c58d115651bdfee3034f7.png";